// src/js/sidebar.ts — localStorage group-collapse persistence (Phase 182, D-10, D-11)
// Pattern: mirrors shared.ts Guard B/C + bootstrap import convention.
// Keys: ksat-sidebar-<groupId>  Values: 'open' | 'closed'

import * as bootstrap from "bootstrap";

export default class {
    static init = () => {
        sidebarPersistence();
    }
}

function sidebarPersistence(): void {
    // Guard C: element absence — exit if no sidebar collapse groups in DOM
    const groups = document.querySelectorAll<HTMLElement>('[data-sidebar-group]');
    if (!groups.length) return;

    // Restore non-active groups from localStorage on load.
    // Active group already has server-emitted `show` class (D-10, SC2) — skip it (Pitfall 3).
    groups.forEach((collapseEl) => {
        const groupId = collapseEl.getAttribute('data-sidebar-group');
        if (!groupId) return;
        // If server emitted `show` (active group), do not override with localStorage (Pitfall 3)
        if (collapseEl.classList.contains('show')) return;

        const saved = localStorage.getItem(`ksat-sidebar-${groupId}`);
        if (saved === 'open') {
            const bsCollapse = bootstrap.Collapse.getOrCreateInstance(collapseEl, { toggle: false });
            bsCollapse.show();
        }
    });

    // Persist state on Bootstrap Collapse events (D-11)
    // Events bubble to document — filter by data-sidebar-group attribute
    document.addEventListener('show.bs.collapse', (e: Event) => {
        const el = e.target as HTMLElement;
        const groupId = el.getAttribute('data-sidebar-group');
        if (!groupId) return;
        localStorage.setItem(`ksat-sidebar-${groupId}`, 'open');
    });

    document.addEventListener('hide.bs.collapse', (e: Event) => {
        const el = e.target as HTMLElement;
        const groupId = el.getAttribute('data-sidebar-group');
        if (!groupId) return;
        localStorage.setItem(`ksat-sidebar-${groupId}`, 'closed');
    });
}
